export default function comercial() {
  return [
    {
      name: 'Inicio',
      icon: 'fa fa-th-large fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: true,
      link: '/app/com/inicio',
    },
    {
      name: 'Prospects',
      icon: 'fa fa-user-plus fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: true,
      link: '/app/com/prospects',
    },
    {
      name: 'Kanban',
      icon: 'fa fa fa-trello fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: true,
      link: '/app/com/kanban',
    },
    {
      name: 'Agenda',
      icon: 'fa fa-calendar fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: true,
      link: '/app/com/agenda-comercial',
    },
    {
      name: 'Históricos/Ocorrências',
      icon: 'fa fa-file-text-o fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: true,
      link: '/app/com/historico-ocorrencia',
    },
    {
      name: 'Relatórios',
      type: 'collapse',
      icon: 'fa fa-file-excel-o fa-fw',
      iconSize: '1.2em',
      children: [
        {
          name: 'Kanban - Conclusão Cartões',
          iconSize: '1.2em',
          type: 'item',
          ativo: true,
          link: '/app/com/rel-kanban-conclusao-cartoes',
        },
      ],
    },
    {
      name: 'Tabelas',
      type: 'collapse',
      icon: 'fa fa-folder-open fa-fw',
      iconSize: '1.2em',
      children: [
        {
          name: 'Prospect - Estágio / Status',
          iconSize: '1.2em',
          type: 'item',
          ativo: true,
          link: '/app/com/status-prospects',
        },
        {
          name: 'Prospect - Perfil',
          iconSize: '1.2em',
          type: 'item',
          ativo: true,
          link: '/app/com/perfil-prospects',
        },
        {
          name: 'Kanban - Motivos Conclusão Cartão',
          iconSize: '1.2em',
          type: 'item',
          ativo: true,
          link: '/app/com/motivo-conclusao-kanban',
        },
      ],
    },
    {
      name: 'Ferramentas',
      type: 'collapse',
      icon: 'fa fa-wrench',
      iconSize: '1.2em',
      children: [
        {
          name: 'Importação de Prospect',
          iconSize: '1.2em',
          type: 'item',
          ativo: true,
          link: '/app/com/prospects-importacoes',
        },
      ],
    },
  ];
}
